import type { LocaleDictionary } from "@/i18n/types";

const nsViewJA = {
  fallbackName: "ビュー",
  create: "ビューを作成",
  openList: "ビュー一覧を開く",
  configFile: {
    bulkDownload: "設定ファイルを一括ダウンロード",
    bulkUpload: "設定ファイルを一括アップロード",
    downloadInProgress: "設定ファイルのダウンロードを実行中...",
    downloadSuccess: "設定ファイルのダウンロードに成功しました",
    downloadError: "設定ファイルのダウンロードに失敗しました",
  },
  row: {
    editSetting: "ビュー設定の確認・変更",
    duplicate: "ビューを複製",
    delete: "ビューを削除",
  },
  listButton: {
    delete: "削除",
    duplicate: "複製",
  },
  duplicate: {
    inProgress: "ビューを複製中...",
    success: "ビューを複製しました",
    error: "ビューを複製できませんでした",
  },
  deleteDialog: {
    title: "ビューの削除",
    message: ({ viewName }: { viewName: string }) =>
      `${viewName}を削除します。削除したビューは元に戻せません。`,
    initialViewWarning:
      "このビューは初期ビューに設定されています。削除すると設定が解除されます。",
    button: "削除",
    inProgressButton: "削除中...",
    success: "ビューを削除しました",
    error: "ビューを削除できませんでした",
  },
} satisfies LocaleDictionary;

export default nsViewJA;
